import { useEffect } from 'react';

export default function useDisableOverflowY(when: boolean) {
  useEffect(() => {
    const property = when ? 'hidden' : 'auto';
    document.querySelector('html')?.style.setProperty('overflow-y', property);
  }, [when]);
}
